import { Record, String as RTString, Static } from 'runtypes';
import { DeepPartial } from 'utility-types';
import { buildService } from './decorated-service';

const api = buildService('nasu-svc/service/nasu-referral');

const CreateReferrerArgs = Record({
  referrerName: RTString,
  referrerEmailAddress: RTString,
  referredName: RTString,
  referredEmailAddress: RTString
});

export type StaticCreateReferrerArgs = Static<typeof CreateReferrerArgs>;

export const postReferrer = (
  args: DeepPartial<StaticCreateReferrerArgs>
): Promise<any> => {
  const validated: StaticCreateReferrerArgs = CreateReferrerArgs.check(args);
  return api.add(validated);
};

export default api;
